/* Rêve de Mur : avant/après et vidéos */
(function(){
  function initCompare(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var range=root.querySelector('.rdm-compare__range');
    var set=function(v){root.style.setProperty('--pos',v+'%');};
    set(range.value);
    range.addEventListener('input',function(){set(range.value);root.classList.add('is-touched');});
    if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){io.disconnect();
          var t0=null,from=50;
          function step(ts){ if(root.classList.contains('is-touched')) return; if(!t0)t0=ts; var p=(ts-t0)/2200; if(p>1)p=1;
            var v=from+Math.sin(p*Math.PI*2)*-28*(1-p*0.3); range.value=v; set(v); if(p<1) requestAnimationFrame(step); else {range.value=50;set(50);} }
          setTimeout(function(){requestAnimationFrame(step);},500);
        }});},{threshold:.5});
      io.observe(root);
    }
  }
  function initVideo(v){
    if(v.dataset.ready) return; v.dataset.ready='1';
    if(!('IntersectionObserver' in window)){v.src=v.dataset.src;v.play&&v.play();return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){ if(!v.src){v.src=v.dataset.src;} var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      else { v.pause(); }
    });},{threshold:.35});
    io.observe(v);
  }
  function boot(scope){
    (scope||document).querySelectorAll('.rdm-compare').forEach(initCompare);
    (scope||document).querySelectorAll('video[data-src]').forEach(initVideo);
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',function(){boot();});
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
